import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["viewProvisionCard", "viewTitle", "viewProvisionCardBody", "previewCard", "editProvisionBtn", "assignBtn", "deleteProvisionBtn", "9999"]

  connect() {
    this.controllerName = `operations--products--bookings--provisions--show`
    this.send_data = { current_user: {}, provision: {}, notification: {} }
    this.doViewHtml()
  }

  doViewHtml() {
    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="viewProvisionCard" data-action="resize@window->operations--products--bookings--provisions--show#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 py-3" style="font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="viewTitle">Nenhuma Provisão Selecionada</h6>
                  </div>
                  <div class="card-body py-0 px-2" style="overflow:auto;" data-${this.controllerName}-target="viewProvisionCardBody"></div>
                </div>`

    this.getControllerByIdentifier("operations--products--bookings--provisions--dashboard").viewTarget.innerHTML = html
  }

  cancelSave() {
    this.current_provision = {}
    this.getControllerByIdentifier("operations--products--bookings--provisions--index").cleanCheckBox()
    this.doViewHtml()
  }

  editProvision() {

    if (this.application.current_date.open) {
      this.getControllerByIdentifier("operations--products--bookings--provisions--save").current_provision = this.current_provision
      this.getControllerByIdentifier("operations--products--bookings--provisions--save").actionMode = "edit"
      this.getControllerByIdentifier("operations--products--bookings--provisions--save").doFormHtml()
    } else {
      this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", this.application.current_date.message, 2000)
    }

  }

  createPayment() {
    var hasDate = false

    if (this.current_provision.date) {
      this.application.dates.forEach(element => {
        if (element.month == this.current_provision.month && element.year == this.current_provision.year && element.open) {
          hasDate = true
        }
      });
      
      if (hasDate) {
        this.requestCreatePayment()
      } else {
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", "A competência do pagamento não existe ou não está aberta.", 2000)
      }
    } else {
      this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", "Favor editar a provisão e adicionar a data do Pagamento.", 2000)
    }

  }

  requestCreatePayment() {
    this.actionMode = `new`
    this.send_data.current_user.current_user_id = this.application.current_user.id

    this.send_data.provision.id = this.current_provision.id
    this.send_data.provision.active = false

    this.send_data.notification.domain_id = this.application.booking.id
    this.send_data.notification.domain_type = "operation_products"
    this.send_data.notification.date_id = this.application.current_date.id
    this.send_data.notification.date_type = "operation_dates"
    this.send_data.notification.kind = `mode_${this.actionMode}`
    this.send_data.notification.action = `${this.getControllerByIdentifier("app--visits--users").getUserName(this.application.current_user)} %mode_${this.actionMode}% o pagamento ${this.current_provision.id_name}, no valor de ${Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 }).format(this.current_provision.amount)} para a competência de ${this.current_provision.accrual_pretty}.`
    this.send_data.notification.account_name = this.application.current_user.name
    this.send_data.notification.account_id = this.application.current_user.account_id


    var url = "/operations/products/bookings/provisions/create_payment"
    var method = "POST"
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          controller.stopRefreshing()
          var provision = response.data.cln.provision
          var payment = response.data.cln.payment
          controller.application.provisions.forEach((element, i) => {
            if (element.id == provision.id) {
              controller.application.provisions.splice(controller.application.provisions.indexOf(element), 1)
            }
          })
          controller.application.payments[controller.application.payments.length] = payment
          controller.cancelSave()
          controller.getControllerByIdentifier("operations--products--bookings--provisions--index").doDataTable()
        } else {
          controller.assignBtnTarget.disabled = false
          if (controller.hasDeleteBtnTarget) {
            controller.deleteBtnTarget.disabled = true
          }
        }
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 2000)
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  deleteProvision() {
    var r = confirm("Desejar apagar a Provisão?")
    this.deleteProvisionBtnTarget.disabled = true

    if (r) {
      this.actionMode = `delete`
      this.send_data.current_user.current_user_id = this.application.current_user.id

      this.send_data.provision.id = this.current_provision.id
      this.send_data.provision.active = false

      this.send_data.notification.domain_id = this.application.booking.id
      this.send_data.notification.domain_type = "operation_products"
      this.send_data.notification.date_id = this.application.current_date.id
      this.send_data.notification.date_type = "operation_dates"
      this.send_data.notification.kind = `mode_${this.actionMode}`
      this.send_data.notification.action = `${this.getControllerByIdentifier("app--visits--users").getUserName(this.application.current_user)} %mode_${this.actionMode}% a provisão ${this.current_provision.id_name}, no valor de ${Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 }).format(this.current_provision.amount)} para a competência de ${this.current_provision.accrual_pretty}.`
      this.send_data.notification.account_name = this.application.current_user.name
      this.send_data.notification.account_id = this.application.current_user.account_id

      if (this.application.current_date.open) {
        this.requestDeleteProvision()
      } else {
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", this.application.current_date.message, 2000)
      }
    } else {
      this.deleteProvisionBtnTarget.disabled = false
    }

  }

  requestDeleteProvision() {
    var url = "/operations/products/bookings/provisions/update"
    var method = "PUT"
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          controller.stopRefreshing()
          var provision = response.data.cln
          controller.application.provisions.forEach((element, i) => {
            if (element.id == provision.id) {
              controller.application.provisions.splice(controller.application.provisions.indexOf(element), 1)
            }
          })
          controller.cancelSave()
          controller.getControllerByIdentifier("operations--products--bookings--provisions--index").doDataTable()
        } else {
          controller.assignBtnTarget.disabled = false
          if (controller.hasDeleteBtnTarget) {
            controller.deleteBtnTarget.disabled = true
          }
        }
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 2000)
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }


  doProvisionViewHtml() {
    var spaceRow = `<td colspan="10" style="height:2rem;padding-top:1rem;padding-bottom:1rem;" scope="col"></td>`

    if (this.current_provision.id_type == "individual") {
      var idType = `CPF`
    } else if (this.current_provision.id_type == "legal") {
      var idType = `CNPJ`
    }

    if (this.application.permissions.medbooking_provisions.can_assign) {
      var assignBtnHtml = `<button type="button" class="btn btn-primary btn-sm py-2 btn-table f-065" data-action="click->operations--products--bookings--provisions--show#createPayment" data-${this.controllerName}-target="assignBtn">Criar Pagamento</button>`
    } else {
      var assignBtnHtml = ``
    }
    
    if (this.application.permissions.medbooking_provisions.can_delete) {
      var deleteBtnHtml = `<button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0 mc-tooltip" data-${this.controllerName}-target="deleteProvisionBtn" data-action="click->operations--products--bookings--provisions--show#deleteProvision" type="button">
                            <span class="material-icons f-1p25">delete</span>
                            <span class="mc-tooltiptext">Apagar Provisão</span>
                          </button>`
    } else {
      var deleteBtnHtml = ``
    }

    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="previewCard" data-action="resize@window->operations--products--bookings--provisions--show#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4" style="padding:1rem;font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="previewTitle">Provisão Consultório</h6>
                    <div class="card-actions ml-auto py-0">
                      <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0 mc-tooltip" data-${this.controllerName}-target="editProvisionBtn" data-action="click->operations--products--bookings--provisions--show#editProvision" type="button">
                        <span class="material-icons f-1p25">edit</span>
                        <span class="mc-tooltiptext">Editar Provisão</span>
                      </button>
                      ${deleteBtnHtml}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;" data-${this.controllerName}-target="previewCardBody">
                    <div class="row my-1">
                      <div class="col-12">
                        <table class="table table-sm table-borderless" style="font-size:80%;">
                          <tbody>
                            <tr>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                            </tr>
                            <tr>
                              <th colspan="2" class="f-065 align-middle px-0">
                                <strong>Beneficiário</strong>
                              </th>
                              <td colspan="8" class="f-065 align-middle px-0 text-left">
                                ${this.current_provision.id_name} <br>
                              </td>
                            </tr>
                            <tr>
                              <th colspan="2" class="f-065 align-middle px-0">
                                <strong>${idType}</strong>
                              </th>
                              <td colspan="8" class="f-065 align-middle px-0 text-left">
                                ${this.current_provision.id_number_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="2" class="f-065 align-middle px-0">
                                <strong>Valor</strong> <br>
                              </th>
                              <td colspan="8" class="f-065 align-middle px-0 text-left">
                                ${Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 }).format(this.current_provision.amount)}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="2" class="f-065 align-middle px-0">
                                <strong>Competência</strong> <br>
                              </th>
                              <td colspan="8" class="f-065 align-middle px-0 text-left">
                                ${this.current_provision.accrual_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="2" class="f-065 align-middle px-0">
                                <strong>Despesa</strong> <br>
                              </th>
                              <td colspan="8" class="f-065 align-middle px-0 text-left">
                                ${this.current_provision.chart}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="2" class="f-065 align-middle px-0">
                                <strong>Anotações</strong> <br>
                              </th>
                              <td colspan="8" class="f-065 align-middle px-0 text-left">
                                ${this.current_provision.notes}
                              </td>
                            </tr>

                            <tr>
                              ${spaceRow}
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer border-top text-right py-1">
                    ${assignBtnHtml}
                  </div>
                </div>`

    // this.viewProvisionCardBodyTarget.innerHTML = html
    // this.getControllerByIdentifier("operations--products--bookings--provisions--dashboard").showTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("operations--products--bookings--provisions--dashboard").viewTarget.innerHTML = html)
    }).then(() => {
      controller.previewCardTarget.style.height = ($(window).height() * 0.5) + "px"
      controller.getControllerByIdentifier("app--helpers--elements").tooltip()
    })

  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    this.connect()
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.assignBtnTarget.disabled = false
      } else {
        controller.assignBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
